export default __webpack_public_path__ + "static/media/home.df2c8266.svg";